import { render } from "./ChangePasswordModal.vue?vue&type=template&id=54ee57b8&scoped=true"
import script from "./ChangePasswordModal.vue?vue&type=script&lang=js"
export * from "./ChangePasswordModal.vue?vue&type=script&lang=js"

import "./ChangePasswordModal.vue?vue&type=style&index=0&id=54ee57b8&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ee57b8"]])

export default __exports__